import { sendMail } from "@/store/services/task/contactMechanism";
import { EmailMessage } from "@/types";

export const USER_ACCOUNT_CREATION_TEMPLATE_ID = "TEMPLATE_Creation_compte_WELEAF";

export type UserAccountCreationEmailPayload = {
  email: string;
  username: string;
  password: string;
};

export async function sendUserAccountCreationEmail(
  payload: UserAccountCreationEmailPayload
): Promise<void> {
  const { email, username, password } = payload;
  if (!email?.trim() || !username?.trim() || !password) {
    throw new Error("Missing required fields for account creation email");
  }

  const normalizedEmail = email.trim();
  const body: EmailMessage = {
    objectType: "odm.contactmechanism.communicationrequest.emailmessage",
    clientApplication: {
      systemUid: "odm-contactmechanism",
      objectType: "odm.contactmechanism.contactmechanismclient",
      resourceUid: "ApplicationClient",
    },
    emailTemplate: {
      objectType: "odm.contactmechanism.emailtemplate",
      systemUid: "odm-contactmechanism",
      resourceUid: USER_ACCOUNT_CREATION_TEMPLATE_ID,
    },
    parameters: {
      recipient_email: normalizedEmail,
      email: normalizedEmail,
      username: username.trim(),
      password,
    },
    businessData: null,
    relatedObjects: null,
    attachments: [],
  };

  await sendMail(body);
}
